import React from "react";
import styles from "../OfferBanner/OfferBanner.module.css";
import offerBanner from "../../Data/RO-landing.json";
const OfferBannerData = offerBanner[0]?.offerBanner;
const OfferBanner = () => {
  return (
    <div className={styles.container}>
      {OfferBannerData.map((elem, index) => {
        return (
          <>
            <img src={elem.imgUrl} alt={elem.catId} />
          </>
        );
      })}
    </div>
  );
};

export default OfferBanner;
